import { useBorrowerLegalExplanations } from '../../../../../../../queries/BorrowerFields/LegalityFields';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface LegalExplanationsProps {
    required?: boolean;
    submitted?: boolean;
    isReview?: boolean;
}

export const LegalExplanations: React.FC<LegalExplanationsProps> = ({ required = false, isReview = false }) => {
    const label = 'Briefly explain any items you answered yes';
    const [legalExplanations, set_legalExplanations] = useBorrowerLegalExplanations();
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={legalExplanations}
                />
            ) : (
                <TextBox
                    value={legalExplanations}
                    onChange={(value) => set_legalExplanations(value)}
                    label={label}
                    required={required}
                />
            )}
        </>
    );
};
